<div>
    <img src='/assets/images/svc.png' usemap='#svcmap' id='svcImg' (window:resize)='onResize($event)'>
    <map name='svcmap'>
        <area shape='rect' [coords]='coordinates' alt='ptn' href='https://www.privatetechnetwork.com'>
    </map>
</div>